import { DEFAULT_SAMPLE_RATE } from './constants.tsx';

export const isInSample = (sampleRate: number = DEFAULT_SAMPLE_RATE) =>
	Math.random() <= 1 / sampleRate;
